<template>
    <div>
        <Echart id="centreLeft2Chart" ref="centreLeft2ChartRef" :options="options" height="400px" width="470px"></Echart>
    </div>
</template>

<script>
import Echart from '@/common/echart';
import china from "@/common/map/china.json";
import xiamen from "../../common/map/city/xiamen.json";
import { cityTransportBySubItem } from '../../api/holdMy'
export default {
    data() {
        return {
            options: {},
            cityList: [
                {
                    name: "上海",
                    value: "shanghai"
                },
                {
                    name: "厦门",
                    value: "xiamen"
                },
                {
                    name: "北京",
                    value: "beijing"
                },
                {
                    name: "温州",
                    value: "wenzhou"
                },
                {
                    name: "广州",
                    value: "guangzhou"
                },
                {
                    name: "保定",
                    value: "baoding"
                },
                {
                    name: "佛山",
                    value: "foshan"
                },
                {
                    name: "宁波",
                    value: "ningbo"
                },
                {
                    name: "杭州",
                    value: "hangzhou"
                },
                {
                    name: "郑州",
                    value: "zhengzhou"
                },
                {
                    name: "济南",
                    value: "jinan"
                },
                {
                    name: "舟山",
                    value: "zhoushan"
                },
                {
                    name: "阿拉善盟",
                    value: "alasanmeng"
                },
                {
                    name: "长沙",
                    value: "changsha"
                },
                {
                    name: "泉州",
                    value: "quanzhou"
                },
                {
                    name: "福州",
                    value: "fuzhou"
                },
                {
                    name: "南昌",
                    value: "nanchang"
                },
                {
                    name: "莆田",
                    value: "putian"
                },
                {
                    name: "惠州",
                    value: "huizhou"
                },
                {
                    name: "重庆",
                    value: "chongqing"
                },
                {
                    name: "临沂",
                    value: "linyi"
                },
                {
                    name: "贵阳",
                    value: "guiyang"
                },
                {
                    name: "苏州",
                    value: "suzhou"
                },
                {
                    name: "漳州",
                    value: "zhangzhou"
                },
                {
                    name: "成都",
                    value: "chengdu"
                },
                {
                    name: "深圳",
                    value: "shenzhen"
                },
                {
                    name: "武汉",
                    value: "wuhan"
                }
            ]
        };
    },
    components: {
        Echart,
    },
    props: {
        cdata: {
            type: Object,
            default: () => "",
        },
        cityName: {
            type: String,
            default: () => "",
        },
    },
    watch: {
        cityName:{
            handler(newData){

            },
            immediate: true,
            deep: true,
        },
        cdata: {
            handler(newData) {
                const rateData = JSON.parse(JSON.stringify(newData));
                if (rateData.name && rateData.name != '' && rateData.name != null) {
                    var data = [
                        { name: '厦门', value: 780, list: [] }
                    ];
                    let cityToday = rateData.list;
                    const city = this.selCity(this.cityList, rateData.name);
                    const json = require(`../../common/map/city/${city}.json`);
                    this.$echarts.registerMap(city, json);
                    var size = parseInt(80 / 1);

                    if (cityToday) {
                        data = cityToday;
                        var data2 = data;
                        var maxQty = 0;
                        for (var j = 0; j < data2.length; j++) {
                            if (data2[j].qty > maxQty) {
                                maxQty = data2[j].qty;
                            }
                        }
                        size = parseInt(Math.sqrt(maxQty) / 1);
                        if (size == 0) { size = 2; }
                    }
                    var convertData = function (dataList) {
                        var res = [];
                        var subitemstring = '';
                        for (var i = 0; i < dataList.length; i++) {
                            var valueArr = [];
                            valueArr.push(dataList[i].longitude);
                            valueArr.push(dataList[i].latitude);
                            valueArr.push(dataList[i].qty);
                            if (dataList[i].subitemName) {
                                subitemstring = '*' + (dataList[i].subitemName.length >= 6 ? dataList[i].subitemName.substring(1, 6) + '*' : dataList[i].subitemName.substring(1, dataList[i].subitemName.length));
                                valueArr.push(subitemstring);
                            }

                            res.push({
                                name: subitemstring,
                                value: valueArr //data[i].value
                            });
                        }
                        return res;
                    };
                    var convertDataArr = convertData(data);

                    this.options = {
                        title: {
                            text: rateData.name,
                            left: "20%",
                            top: "10%",
                            textStyle: {
                                color: "#fff",
                                fontSize: '26',
                            },
                            zlevel: 3
                        },
                        tooltip: {
                            trigger: 'item',
                            formatter: function (params, ticket, callback) {
                                return params.name + " : " + params.value[2] + " 次";
                            }
                        },
                        geo: {
                            // show: true,
                            map: city,
                            label: {
                                emphasis: {
                                    show: true,
                                    color: '#D4EEFF'//字体颜色
                                },
                                normal: {
                                    show: true,
                                    fontSize: "10",
                                    color: "#BEBEBE",
                                },
                            },
                            roam: false, //鼠标拖拽和方法缩小
                            zoom: 1.1,
                            itemStyle: {
                                normal: {  //静态的时候显示的默认样式
                                    areaColor: '#00CCFF',
                                    borderColor: '#00CCFF',
                                    shadowOffsetX: 0,
                                    shadowOffsetY: 0,
                                    opacity: 0.3, // 透明度
                                    borderWidth: 1, // 省份界线的宽度
                                },
                                emphasis: {  //鼠标悬停时区域变成的颜色
                                    areaColor: '#00CCFF',
                                    borderColor: '#00CCFF',
                                    color: '#fff',//字体颜色
                                    opacity: 0.5, // 透明度
                                }
                            }
                        },
                        series: [
                            {
                                name: '实时行驶车辆',
                                type: 'scatter',
                                coordinateSystem: 'geo',
                                data: convertDataArr,
                                symbolSize: function (val) {
                                    return (val[2] / size )+ 5;
                                },
                                // symbolSize: 2,
                                label: {
                                    normal: {
                                        formatter: '{@[2]}',
                                        position: ['50%', '50%'],
                                        show: false
                                    },
                                    emphasis: {
                                        show: false
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: 'white', //#f35ca2   #98af61 #f5f0f0 #e80a5b #dca6d3
                                        fontStyle: 'normal',
                                        fontFamily: '微软雅黑',
                                        fontSize: 15,
                                    }
                                },
                                zlevel: 1
                            },

                            {
                                name: 'Top 5',
                                type: 'effectScatter',
                                coordinateSystem: 'geo',
                                data: convertData(data.sort(function (a, b) {
                                    return b.value - a.value;
                                }).slice(0, 5)),//
                                symbolSize: function (val) {
                                    return (val[2] / size / 2) + 4;
                                },
                                showEffectOn: 'render',
                                rippleEffect: {
                                    brushType: 'stroke',
                                },
                                hoverAnimation: true,
                                label: {
                                    normal: {
                                        formatter: '{b}',
                                        position: ['50%', '50%'],
                                        show: true,
                                        color: 'white',
                                        fontStyle: 'normal',
                                        fontFamily: '微软雅黑',

                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        color: '#FFF45C',
                                        shadowBlur: 10,
                                        shadowColor: 'rgba(0,0,0,.3)'
                                    }
                                },
                                zlevel: 3
                            }
                        ],

                    };
                }

            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        // 找对应的城市名
        selCity(arr, key) {
            for (var i = 0; i < arr.length; i++) {
                // 遍历每个数组的对象元素的某个key值和value进行对比，相等返回当前元素下标，不等的话，返回null
                if (arr[i].name == key) {
                    return arr[i].value;
                }
            }
            return null;
        },
        // // 获取城市信息
        // getCityTransportBySubItem(city) {
        //     let data = {
        //         autoIncId: 1,// id
        //         city: city + "市"
        //     }
        //     cityTransportBySubItem(data).then(res => {
        //         this.cdata=[];
        //         let list = [];
        //         if (res.result == 0) {
        //             console.log("城市");
        //             console.log(res);
        //             let data = res.userdata;
        //             this.cdata.list=data;

        //         }


        //         // if (res.result == 0) {
        //         //     console.log("城市");
        //         //     console.log(res.userdata);
        //         //     let data = res.userdata;
        //         //     this.cList.forEach(item => {
        //         //         if (item.name == city.name ) {
        //         //             list.push({name:item.name,value:item.value,list:data});
        //         //         }else{
        //         //             list.push({name:item.name,value:item.value,list:[]});
        //         //         }
        //         //     })
        //         //     this.cdata=list;
        //         //     console.log(this.cdata);
        //         // }
        //     }).catch(error => {
        //         console.log(error);
        //     })
        // },
    },
};
</script>
